import {ChangeDetectionStrategy, Component, effect, inject, input, signal} from '@angular/core';
import {UploadRepositoryService, LocalStorageService} from '@xmedical/core';

@Component({
    selector: 'xui-profile-picture',
    templateUrl: './profile-picture.component.html',
    styleUrls: ['./profile-picture.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilePictureComponent {

  private uploadRepository = inject(UploadRepositoryService);
  private localStorage = inject(LocalStorageService);

  readonly imageKey = input('');
  readonly src = signal('/assets/img/default-avatar.png');

  constructor() {
    effect(() => {
      this.getImgSrc(this.imageKey());
    });
  }

  getImgSrc(imageKey: string) {
    if (!imageKey) {
      this.src.set('/assets/img/default-avatar.png');
      return;
    }
    const expiryDuration = 60 * 60 * 24;
    if (imageKey.length !== 0) {
      const currentUrl: SignedUrl = this.localStorage.getItem(imageKey);
      if (currentUrl != null && currentUrl.expiry > new Date().getTime()) {
        this.src.set(currentUrl.url);
      } else {
        this.uploadRepository.getSignedAssetsUrl(imageKey, 'GET', expiryDuration).subscribe(url => {
          this.src.set(url);
          const signedUrl = {
            url: url,
            expiry: this.generateExpiryDate(expiryDuration)
          };
          this.localStorage.setItem(imageKey, signedUrl);
        }, error => {
          console.error(error);
        });
      }
    }
  }

  private generateExpiryDate(durationInSeconds: number): number {
    const currentDate = new Date();
    return new Date(currentDate.getTime() + durationInSeconds * 1000).getTime();
  }
}

export interface SignedUrl {
  url: string;
  expiry: number;
}
